// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__2mX-z","borderedInput":"Input_borderedInput__3wN8J"};